import p from './store-rebind-log.vue';

export default p;
